import { render, staticRenderFns } from "./ZZLColumnDesign.vue?vue&type=template&id=5bebce83&scoped=true"
import script from "./ZZLColumnDesign.vue?vue&type=script&lang=js"
export * from "./ZZLColumnDesign.vue?vue&type=script&lang=js"
import style0 from "./ZZLColumnDesign.vue?vue&type=style&index=0&id=5bebce83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebce83",
  null
  
)

export default component.exports